import React from 'react'
import { shouldShowInsuranceTooltip } from '../../../domain/useCases/insurance/shouldShowInsuranceTooltip'
import { shouldDisplayCashPayRate } from '../../../domain/useCases/insurance/shouldDisplayCashPayRate'
import { filterAndJoinAcceptedInsurance } from '../../../domain/useCases/insurance/filterAndJoinAcceptedInsurances'
import shield from '../../../images/shield.svg'
import IconPricing from '@/components/IconPricing/IconPricing'
import { ArrowRightShort } from 'react-bootstrap-icons'
import Popover from '@/components/atoms/Popover/Popover'
import IconChevronDownXs from '@/components/icons/IconChevronDownXs/IconChevronDownXs'

const PriceShowcase = ({
  slug,
  price_label,
  preventDefault,
  accepted_insurance,
  insurance_description,
  verify_insurance_link,
  isProfileIntro,
  currentRefinements
}) => {
  const shouldShowCashPriceLabel = () => {
    return shouldDisplayCashPayRate({
      currentRefinements,
      price_label
    })
  }

  const redirectToProfile = (e, target) => {
    e.preventDefault()
    window.open(target, '_blank')
    return
  }

  const doShowInsuranceInfo =
    accepted_insurance?.length > 0 &&
    insurance_description?.length > 1 &&
    verify_insurance_link

  const showInsuranceTooltip = shouldShowInsuranceTooltip({
    acceptedInsurance: accepted_insurance,
    insuranceDescription: insurance_description,
    verifyInsuranceLink: verify_insurance_link
  })

  const acceptedInsurance = filterAndJoinAcceptedInsurance(
    accepted_insurance,
    currentRefinements?.accepted_insurance
  )

  if (!showInsuranceTooltip && !shouldShowCashPriceLabel()) {
    return null
  }

  return (
    <div className="flex flex-wrap gap-x-1.5">
      {showInsuranceTooltip && (
        <div className="flexitems-center cursor-pointer ">
          <div
            className="hidden md:block"
            onClick={(e) => {
              preventDefault && e.preventDefault()
            }}
          >
            <Popover
              header={
                insurance_description?.length > 1
                  ? "Provider's Policy"
                  : 'Insurance Accepted'
              }
              description={
                insurance_description ??
                'This center accepts insurance, exact cost can vary depending on your plan and deductible.'
              }
              buttonLinkText={
                doShowInsuranceInfo ? 'Covered plans and benefit check' : ''
              }
              buttonLinkTarget={
                doShowInsuranceInfo ? `/${slug}/#profile-insurance` : ''
              }
              buttonLinkIcon={<ArrowRightShort size="16" />}
              placement="bottom-start"
            >
              <div className="flex items-center gap-x-1.5">
                <img
                  src={shield}
                  alt="shield icon"
                />
                <span className="flex h-[11px] text-[11px] font-medium leading-[11px] text-gray-800">
                  {acceptedInsurance
                    ? `${acceptedInsurance}`
                    : 'Insurance Accepted'}
                </span>
                <IconChevronDownXs
                  strokeWidth="0.2"
                  className="-ml-1 text-gray-800"
                />
              </div>
            </Popover>
          </div>
          <div className="md:hidden">
            <span
              onClick={(e) =>
                redirectToProfile(e, `/${slug}/#profile-insurance`)
              }
            >
              <div className="flex items-center">
                <img
                  className="mr-1.5"
                  src={shield}
                  alt="shield icon"
                />
                <span className="flex h-[11px] pt-px text-[11px] font-medium leading-[11px] text-gray-800">
                  {acceptedInsurance
                    ? `${acceptedInsurance}`
                    : 'Insurance Accepted'}
                </span>
                <IconChevronDownXs
                  strokeWidth="0.2"
                  className="ml-[3px] mt-px -rotate-90 text-gray-800"
                />
              </div>
            </span>
          </div>
        </div>
      )}
      {!showInsuranceTooltip && shouldShowCashPriceLabel() && (
        <div className="flex cursor-pointer items-center">
          <div
            className="hidden md:block"
            onClick={(e) => {
              preventDefault && e.preventDefault()
            }}
          >
            <Popover
              header="Estimated Cash Pay Rate"
              description={`The cost listed here (${price_label}) is an estimate of the cash pay price. Center pricing can vary based on program and length of stay. Contact the center for more information. Recovery.com strives for price transparency so you can make an informed decision. `}
              buttonLinkText={isProfileIntro ? '' : 'View Full Profile'}
              buttonLinkTarget={isProfileIntro ? '' : `/${slug}/#center-price`}
              buttonLinkIcon={<ArrowRightShort size="16" />}
              placement="bottom"
            >
              <div className="flex flex-row items-center text-green-600">
                <IconPricing />
                <span className="ml-[6px] line-clamp-1 flex h-[11px] text-[11px] font-medium leading-[11px] text-gray-800">
                  {!showInsuranceTooltip ? price_label : 'Cash Pay Rate'}
                </span>
                <IconChevronDownXs
                  strokeWidth="0.2"
                  className="ml-[2px] text-gray-800"
                />
              </div>
            </Popover>
          </div>
          <div className="md:hidden">
            <span
              className="flex flex-row items-center"
              onClick={(e) => redirectToProfile(e, `/${slug}/#center-price`)}
            >
              <div className="flex flex-row items-center text-green-600">
                <IconPricing />
                <span className="ml-[6px] flex h-[11px] pt-px text-[11px] font-medium leading-[11px] text-gray-800">
                  {!showInsuranceTooltip ? price_label : 'Cash Pay Rate'}
                </span>
              </div>
              <IconChevronDownXs
                strokeWidth="0.2"
                className="ml-[3px] mt-px -rotate-90 text-gray-800"
              />
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

export default PriceShowcase
